import services from './../../../services/service'; // Service Class
import MainFooter from './../../MainFooter/index.vue'; // Main Footer ///for first show orders
// import utility from './../../../services/utility'; // Utility Class

let service = new services();
// let util = new utility();
// import ProductForm from '../../../components/product/ProductForm.vue'
// import ProductItemForm from '../../../components/product/ProductItemForm.vue'
// import ProductCartActions from '../../../components/product/ProductCartActions.vue'

//let service = new services();

import {
  ADD_TO_CART,
  REMOVE_FROM_CART
} from '../../../store/mutation-types'
export default {
    name: 'Checkout',
    data () {
        return {
          user: {},
          selected_order:[],
          checkout_orders: {},
          delivery_details: [],
          payment_details: {},
          payment_mode:"",
          request_page: "orders",
          checked_out: [],
          processed_checkout_orders: [],
          sorted_cart: [],
          orders: [],
          cart: this.$store.state.cart,
          img_product_url: service.imageProductsURL,
          item_delivery_fee:"",
          delivery_fee: "",
          payment_option: "",
          total_order_items_total:0.0,
          total_orders_amount:0.0,
          total_order_coupon_amount:0.0,
          total_shipping_fee:0.0,
          total_processing_fee:0.0,
          states:{},
          cities:[],
          set_cities:[],
          loggedIn: false,
          new_account:true,
          process_count:0,
          checkout_processed:false,
          data_error_message:"",
          data_success_message:"",
          is_logged_in_order_mode:0,
          disable_btn:false,
          loading:true,
          action_loading:false,
          user_delivery_address:"",
          order_delivery_state:"",
          order_delivery_city:"",
          //
          shipping_locations:{},
          order_delivery_main_location:{},
          order_delivery_sorted_locations:{},
          group_set_order_delivery_key:0,
          data_processing_message:"",
          componentOrderSummaryKey:0,
          componentOrderMainLocation:0,
          processed_single_order_count:0,
          payment_active_resolve_ref:"",
          process_orders_update: [],
        }
      },
    components: {
        'component-footer':MainFooter
      },
      computed: {
        // a computed getter
        // totalDeliveryFee: function () {
        //     this.sorted_cart.forEach(function(element) {
        //         console.log(element['delivery_option_fee'])
        //         /////this.total_delivery_fee += element['delivery_option_fee']
        //         return element['delivery_option_fee']
        //     });
        // }
      },
     methods:{
        setComponent(attr1,attr2){
            if(attr1 == 'login'){
                this.new_account = false;
            }
            if(attr1 == 'new-account'){
                this.new_account = true;
            }
            if(attr1 == 'change-delivery-option'){
                this.checkout_orders[attr2].change_delivery_option = true;
                document.getElementById("cdl"+attr2).style= "display:block;";
                document.getElementById("cdlb"+attr2).style= "display:none;";
            }
            if(attr1 == 'cancel-change-delivery-option'){
                this.checkout_orders[attr2].change_delivery_option = false;
                document.getElementById("cdl"+attr2).style= "display:none;";
                document.getElementById("cdlb"+attr2).style= "display:block;";
            }
            if(attr1 == 'close-enter-delivery-address'){
                this.checkout_orders[attr2].data_processing_message = "";
                this.checkout_orders[attr2].show_address_input = false;
                this.componentOrderSummaryKey++;
                // document.getElementById("show-address-input"+attr2).style= "display:none;";
               
            }
            
        },

        toggleViews(view){
            if(document.getElementById(view).style.display == "block"){
                document.getElementById(view).style= "display:none;";
            }else{
                document.getElementById(view).style= "display:block;";
            }
        },

        closeViews(view){
            document.getElementById(view).style= "display:none;";
        },
        
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        removeFromCheckout(group_index,order,item) { //NOT USED FOR NOW // MAY BE CHANGED TO CANCELLED
            const index = this.checkout_orders[group_index].order_items.findIndex(ord => ord.order_item_no === item.order_item_no) //best removal
            this.checkout_orders[group_index].order_items.splice(index, 1);
            if(this.checkout_orders[group_index].order_items.length == 0){//remove froup
                const index2 = this.checkout_orders.findIndex(o => o.order_id === order.order_id) //best removal
                this.checkout_orders.splice(index2, 1);
            }
        },

        getStates(){
            service.getStates(this).then(response => {
                if(response.body.status == 200) {
                    this.states = response.body.data;
                }
            }).catch((err) => {})
        },

        getCities(state){
            this.activate_processing();
            service.getCities(this,state).then(response => {
                if(response.body.status == 200) {
                    this.cities =  response.body.data;
                    this.deactivate_processing();
                }
            }).catch((err) => {this.deactivate_processing()})
        },

        setCities(state){
            if(state != undefined){
                this.activate_processing();
                service.getCities(this,state.state_id).then(response => {
                    if(response.body.status == 200) {
                        this.set_cities =  response.body.data;
                        this.deactivate_processing();
                    }
                }).catch((err) => {this.deactivate_processing()})
            }
        },

        setOrderLocations(location){
            if(location.city != undefined){
                this.order_delivery_main_location.address = ''; //empty
                //loop through orders
                let i = 0;
                for (let group of this.checkout_orders) { 
                    // i = this.sorted_cart.indexOf(group);
                    if((group.order_business_delivery_options) &&(group.order_business_delivery_options.length == 0)){//if has not business delivery location
                        //set new sellpoint delivery option
                        this.checkout_orders[i].order_delivery_city = location.city.city_name;
                        this.checkout_orders[i].order_delivery_city_id = location.city.city_id;
                        this.checkout_orders[i].order_delivery_state_id = location.state.state_id;
                        this.checkout_orders[i].order_delivery_state = location.state.name;

                        this.checkout_orders[i].order_user_delivery_address = ""; //empty incase of //change
                        //new settings
                        if((this.checkout_orders[i].order_user_city_delivery == 'error') || (this.checkout_orders[i].order_user_city_delivery == undefined)){
                            this.checkout_orders[i].order_user_city_delivery = location.city.city_id;
                            //get users addresses under this order_user_city_delivery
                            for (let loc of this.delivery_details) { 
                                if(location.city.city_id == loc.user_delivery_city_id){//if has not business delivery location
                                    let address_array = []; //use this to collect array and match with same attribute name as on server
                                    address_array["address_id"] = loc["user_delivery_id"];
                                    address_array["address_city"] = loc["user_delivery_city_id"];
                                    address_array["address_address"] = loc["user_delivery_address"];
                                    this.checkout_orders[i].order_user_city_delivery_addresses.push(address_array);
                                }
                            }
                        }
                        this.checkout_orders[i].show_address_input = true;//order group can show input
                        this.group_set_order_delivery_key++;
                    }
                    i++;
                }
                this.order_delivery_main_location.show_address_input = true;
                this.componentOrderMainLocation++;
            }
        },

        setOrderLocationAddress(location){
            if(location.city != undefined){
                //loop through orders
                let i = 0;
                for (let group of this.checkout_orders) { 
                    // i = this.sorted_cart.indexOf(group);
                    if((group.order_business_delivery_options) &&(group.order_business_delivery_options.length == 0)){//if has not business delivery location
                        //set new sellpoint delivery option
                        this.checkout_orders[i].order_user_delivery_address = location.address;
                        //clear all errors in this order group
                        group.data_processing_message = "";
                        this.group_set_order_delivery_key++;
                    }
                    i++;
                }
            }
        },

        setSortedOrderLocationAddress(location){
            if(location != undefined){
                //loop through orders
                let i = 0;
                for (let group of this.checkout_orders) {
                    // i = this.sorted_cart.indexOf(group);
                    if((group.order_business_delivery_options) &&(group.order_business_delivery_options.length != 0)){//if has not business delivery location
                        //set new sellpoint delivery option
                        if(group.order_delivery_city_id == location.city_id){
                            this.checkout_orders[i].order_user_delivery_address = location.address;
                            this.group_set_order_delivery_key++;
                        }
                    }
                    i++;
                }
            }
        },

        resetDeliveryLocation(i,location){
            if(location != undefined){
                this.checkout_orders[i].order_delivery_city = location.city_name;
                this.checkout_orders[i].order_delivery_city_id = location.city_id;
                this.checkout_orders[i].order_delivery_state_id = this.checkout_orders[i].order_delivery_selected_state.state_id;
                this.checkout_orders[i].order_delivery_state = this.checkout_orders[i].order_delivery_selected_state.name;
                
                this.checkout_orders[i].order_user_delivery_address = ""; //reset
                // this.group_set_order_delivery_key++;
            }
        },

        resetDeliveryLocationAddress(index,location){
            if(location != undefined){
                this.checkout_orders[index].order_user_delivery_address = location.address;
                this.group_set_order_delivery_key++;
            }
        },

        getOrderLocations(index,state){
            this.activate_processing();
            //get the group order business locations for filtering
            let order_array = this.checkout_orders[index].order_business_delivery_options;
            this.checkout_orders[index].sorted_order_business_delivery_options = order_array.filter(function(item){ return item.business_delivery_state_id==state.state_id;});
            // document.getElementById("odl"+index).style= "display:block;";
            this.deactivate_processing();
        },
       
        loginAndProcess(){
            this.activate_processing();
            service.loginUser(this, this.user).then(response => {
                if(response.body.status == 200) {
                    let data = response.body.data;
                    this.user = data; 
                    var user_data = {
                        "user_name": data.user_name,
                        "user_id": data.user_id,
                        "sp_token": data.user_session_key,
                        "sp_token_key": data.user_token_key
                    }
                    localforage.setItem(service.udb_name, user_data).then(function (value) {}).catch(function(err) {});
                    // localStorage.setItem("sp_user", data.user_name); 
                    // localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                    // localStorage.setItem("sp_token_key", data.user_token_key); 
                   
                    // if(!this.new_account){ ///not new account
                        this.is_logged_in_order_mode = 1;
                        this.process_checkout();
                        this.deactivate_processing();
                    // }
                }else{
                this.data_error_message = "Sorry, these login details are invalid.";
                this.deactivate_processing();
                }
            }).catch((err) => {
                this.deactivate_processing();
            })
        },

        preset_xtra() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            //this.checkout();
                            this.loggedIn = true;
                            //check if order has a specified url
                            if(this.$route.params.ckid != null){
                                this.order_url = this.$route.params.ckid;
                                this.getCheckoutOrdersByURL();
                            }else{//get orders with this user id
                                this.getCheckoutOrders();
                            }
                            this.checkout_processed = true; //already processed
                            this.loading = false;
                            //..DEPRAC
                            // if(this.$route.query["order"]){
                            //     this.getCheckoutOrder()
                            // }else{
                            //     this.getCheckoutOrders();
                            // }
                            //..DEPRAC
                            this.getUserDeliveryDetails();
                        }, this);
                    }else {
                    // this.$router.push('login');
                    }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('login');
                        // console.log(err)
                    }
                })
            }else {
            // this.$router.push('login');
            }
        },

        preset(){
        // this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.new_account = false;
                    //check if order has a specified url
                    if(self.$route.params.ckid != null){
                        self.order_url = self.$route.params.ckid;
                        self.getCheckoutOrdersByURL();
                    }else if(self.$route.params.rmkoref != null){ //a re-make order request
                        self.getCheckoutOrdersByReMake(self.$route.params.rmkoref);
                    }else{//get orders with this user id
                        // console.log("43ww")
                        self.getCheckoutOrders();
                    }
                    self.checkout_processed = true; //already processed
                    self.loading = false;
                    self.getUserDeliveryDetails();
                }else {
                    self.getCheckoutLocalOrder();
                }
            });
           
        },

        //local orders stored in forage for NOT-LoggedIn users
        getCheckoutLocalOrder(){
            this.loading = true;
            //use localforage to store and get for now ... if not working well accross points then send to hostdb
            //get from localforage
            // this.activate_processing();
            let self = this;
            //serve from forage first
            setTimeout(function(){ 
                localforage.getItem('not_loggedin_processed_orders').then(function(value) {
                    if(value != null){
                        self.checkout_orders = value;
                    }
                    self.loading = false;
                }).catch(function(err) {
                    //report error
                    this.loading = false;
                    location.replace("/orders/");  //no checkout items
                });
            }, 500)        
        },

        //logged In User
        getCheckoutOrders(){
            this.activate_processing();
            service.getCheckoutOrders(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.setCheckoutOrders(response);
                }else{ 
                    this.$router.push("/orders/");  //no checkout items
                }
            }).catch((err) => {
                // console.log(err)
                this.deactivate_processing(); 
                // this.$router.push("orders");  //no checkout items
            })
        },

        //Order with specified URL
        getCheckoutOrdersByURL(){
            this.activate_processing();
            service.getCheckoutOrder(this, this.order_url).then(response => {
                if(response.body.status == 200) {
                    //check if order has been paid for or not-paid
                    let data = response.body.data;
                    if((data[0]["order_payment_status_id"]) && (data[0]["order_payment_status_id"] != 2)){ //order paid
                        this.setCheckoutOrders(response);
                    }else{
                        location.replace("/orders/");   //no checkout items
                    }
                }else{
                    this.deactivate_processing();
                    location.replace("/orders/");   //no checkout items
                }
            }).catch((err) => {
                this.deactivate_processing();
                location.replace("/orders/");  //no checkout items
            })
        },

    
        //Order with specified URL
        getCheckoutOrdersByReMake(order_ref){
            this.activate_processing();
            service.getCheckoutOrderReMake(this, order_ref).then(response => {
                if(response.body.status == 200) {
                    //check if order has been paid for or not-paid
                    let data = response.body.data;
                    if((data[0]["order_payment_status_id"]) && (data[0]["order_payment_status_id"] != 2)){ //order paid
                        this.setCheckoutOrders(response);
                    }else{
                        location.replace("/orders/");   //no checkout items
                    }
                }else{
                    this.deactivate_processing();
                    location.replace("/orders/");   //no checkout items
                }
            }).catch((err) => {
                this.deactivate_processing();
                location.replace("/orders/");  //no checkout items
            })
        },

        //set the order responses
        setCheckoutOrders(response){
            //after successful request from remote 
            this.checkout_orders = response.body.data;
            
            //add some settings
            let remove_orders = []
            this.checkout_orders.forEach(function(order){
                order.display_delivery = false; //initiate toggle effect
                order.cities = {};
               order.data_processing_message = "";
                //remove orders with no order item //CHECKS
                if(order.order_items.length == 0){//remove froup
                    remove_orders.push(order);
                }
            },this);
            for(let order of remove_orders){
                const order_index = this.checkout_orders.findIndex(o => o.order_id === order.order_id)
                this.checkout_orders.splice(order_index, 1);
            }
            //continue
            this.total_order_items_total = response.body.data_calculated_orders_amount;
            // this.total_orders_amount = response.body.data_total_orders_amount;
            this.total_orders_amount = response.body.data_total_amount;
            this.total_order_coupon_amount = response.body.data_calculated_coupons;
            this.total_shipping_fee = response.body.data_calculated_shipping_fee;
            this.total_processing_fee = response.body.data_total_orders_processing_fee;
            this.delivery_details = response.body.data_user_delivery_details;
            this.payment_details = response.body.payment_data;
            
            //sort order shipping locations for harmonization
            this.sortOrderLocations();
            
            //show processed
            this.checkout_processed = true;
            if(this.new_account){
                this.loginAndProcess();
            }
            this.deactivate_processing();
        },

        sortOrderLocations(){
            //loop through orders
            let i = 0;
            let locations = [];
            this.order_delivery_sorted_locations.cities = [];
            for (let group of this.checkout_orders) { 
                //loop through sorted orders to check match
                // for (let location of this.order_delivery_sorted_locations.cities) { console.log("2222p0p0p0")
                    if(((group.order_business_delivery_options) && (group.order_business_delivery_options.length != 0))){//if has business delivery location
                        let delivery_arr = {city_id:group.order_delivery_city_id, city_name:group.order_delivery_city};
                        // if(this.order_delivery_sorted_locations.cities.indexOf(delivery_arr) == -1){
                            // this.order_delivery_sorted_locations.cities.push(delivery_arr);
                        locations.push(delivery_arr);
                        // } 
                    }
                // }
                i++;
            }

            //push into sorted
            for (let location of locations) { 
                //loop through sorted orders to check match
                if(this.order_delivery_sorted_locations.cities.indexOf(location) == -1){
                    this.order_delivery_sorted_locations.cities.push(location);
                }
            }
        },

        getUserDeliveryDetails(){
            service.getUserDeliveryDetails(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.delivery_details = response.body.data;
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        //processing
        //new ../buy-now/order/notloggedIn
        prep_process_checkout(){
            //validate user details
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            // let phone_test = re_phone.test(String(this.user.user_phone).toLowerCase()); //unused for now
            let phone_test = true;
            if((email_test == false) || (this.user.user_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                //get from localforage and send to db with users details
                //some settings
                //new-user settings
                this.user.user_has_shipping_details = false;
                this.user.user_password = this.user.user_name; //dummy
                this.user.new_set_account = true;

                //create a user, //login and  //then continue there with process_order
                service.regUser(this,this.user).then(function(data) {
                    if(data.body.status == 201) {
                        this.loginAndProcess();
                    }
                }).catch((err) => {
                    this.data_error_message = "Something went wrong while account was being processed";
                    //log-this
                })

                //process--DEPRAC
                //this.process_checkout();
            }//end validate
                
        },

        process_checkout(){
            this.activate_processing();
            //get from localforage and send to db with users details

            //thread-like this
            let promises = [];
            let promise_thread_count = 0;

            if(this.process_count != this.checkout_orders.length){
                this.checkout_orders.forEach(function(processed_checkout) { //groups
                    this.order_url = this.checkout_orders[0].order_business + (new Date().getTime());
                    processed_checkout.order_mode = this.is_logged_in_order_mode; //not loggedIn
                    processed_checkout.order_url = this.order_url;
                    if(!this.new_account){
                        processed_checkout.order_user_id = this.user.user_id;
                    }else{
                        processed_checkout.order_user_details = this.user;
                    }
                    //UPS
                    processed_checkout.order_user_id = this.user.user_id;
                    processed_checkout.order_mode = 1;//not loggedin 
                    //add each order batch
                    //thread-like this
                    promise_thread_count++;
                    promises.push(
                        this.processCheckoutThread(processed_checkout)
                    )
                
                    ///DEPRAC
                    // service.checkout(this,processed_checkout).then(function(data) {
                    //     if(data.body.status == 201) {
                    //         this.process_count++;
                    //     }
                    //     if(this.process_count == this.checkout_orders.length){
                    //         //get tht new users details for login
                    //     // this.user = data.body.data_user_details;
                    //         this.getCheckoutOrdersByURL();
                    //     }
                    //     this.deactivate_processing();
                
                    // }).catch((err) => {
                    //     if(err) {
                    //         // toastr.warning("Something went wrong", 'Warning!'); 
                    //         this.deactivate_processing();
                    //     } 
                    // })
                    ///DEPRAC
                }, this);
            }

            if(promise_thread_count == this.checkout_orders.length){
                //process all promises
                Promise.all(promises)
                .then(() => {})
                .catch((e) => {});
            }
            
            
        },

        processCheckoutThread(processed_checkout){
            service.checkout(this,processed_checkout).then(function(data) {
                if(data.body.status == 201) {
                    this.process_count++;
                }
                //then get orders for setting
                if(this.process_count == this.checkout_orders.length){
                    this.checkout_orders = []; //empty
                    this.preset(); //REFLOW
                } 
                this.deactivate_processing();
            }).catch((err) => { })
        },


        process_checkoutXX(){
            this.activate_processing();
            //get from localforage and send to db with users details
            this.checkout_orders.forEach(function(processed_checkout) { //groups
                this.order_url = this.checkout_orders[0].order_business + (new Date().getTime());
                processed_checkout.order_mode = this.is_logged_in_order_mode; //not loggedIn
                processed_checkout.order_url = this.order_url;
                if(!this.new_account){
                    processed_checkout.order_user_id = this.user.user_id;
                }else{
                    processed_checkout.order_user_details = this.user;
                }
                //add each order batch
                service.checkout(this,processed_checkout).then(function(data) {
                    if(data.body.status == 201) {
                        this.process_count++;
                    }
                    if(this.process_count == this.checkout_orders.length){
                        //get tht new users details for login
                    // this.user = data.body.data_user_details;
                        this.getCheckoutOrdersByURL();
                    }
                    this.deactivate_processing();
            
                }).catch((err) => {
                    if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        this.deactivate_processing();
                    } 
                })
            }, this);  
        },

        //...new
        pre_checkout(){
        //check login
        this.preset();
        },
         
        displayDeliveryOptions(order){
            this.selected_order = [];
            this.selected_order = order;
            if(this.selected_order.display_delivery){
                this.selected_order.display_delivery = false;
            }else{
                this.selected_order.display_delivery = true;
            }
        },
       
        calc_delivery_feeXXXX(i,option){
            if(option != undefined){
                //subtract current delivery fee from sellpoint total order and general total order
                this.total_orders_amount -= Number(this.checkout_orders[i].order_delivery_fee); //general
                this.checkout_orders[i].order_total -= Number(this.checkout_orders[i].order_delivery_fee); //sellpoint\
                this.total_shipping_fee -= Number(this.checkout_orders[i].order_delivery_fee); //general

                //set new sellpoint delivery charge
                this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
                this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;
                this.checkout_orders[i].order_delivery_city = option.business_delivery_option;

                //set the delivery charge to sellpoint total order and general total order
                this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
                this.checkout_orders[i].order_delivery_fee = Number(option.business_delivery_option_price);

                //update delivery fee with new one
                this.total_orders_amount += Number(option.business_delivery_option_price); //general
                this.checkout_orders[i].order_total += Number(option.business_delivery_option_price); //sellpoint
                this.total_shipping_fee  += Number(option.business_delivery_option_price); //general

                //update address
                this.delivery_details.forEach(function(detail) {
                    if(detail.user_delivery_city == option.business_delivery_option){
                        //empty previous city delivery addresses
                        this.checkout_orders[i].order_user_delivery_addresses = [];
                        //now push matching addresses to this city
                        this.checkout_orders[i].order_user_delivery_addresses.push(detail);
                    }
                }, this);
            }
            
        },

        calc_delivery_fee(i,option){
            if(option != undefined){
                //subtract current delivery fee from sellpoint total order and general total order
                this.total_orders_amount -= Number(this.checkout_orders[i].order_delivery_fee); //general
                this.checkout_orders[i].order_total -= Number(this.checkout_orders[i].order_delivery_fee); //sellpoint\
                this.total_shipping_fee -= Number(this.checkout_orders[i].order_delivery_fee); //general

                //reset 
                this.checkout_orders[i].order_delivery_fee = 0;
                this.checkout_orders[i].order_user_delivery_address = "";

                //reset the order fee for items with this order delivery option
                for(let item of this.checkout_orders[i].order_items) { 
                    item.order_item_delivery_fee = 0;
                }

                //set new sellpoint delivery option
                this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
                this.checkout_orders[i].order_delivery_city = option.business_delivery_option;
                this.checkout_orders[i].order_delivery_city_id = option.business_delivery_city;
                this.checkout_orders[i].order_delivery_state_id = option.business_delivery_state_id;
                this.checkout_orders[i].order_delivery_state = option.business_delivery_state;
                // this.checkout_orders[i].order_delivery_selected_state = option;

                //calculate
                //check: if option does not have product delivery fees set
                let fees =  option.business_products_delivery_fees;
                if(fees.length == 0){
                    //calculate delivery with Business Constraints
                    if(this.checkout_orders[i].business_shipping_calculation_method == 9){ //one charge for all items ordered in this business
                        this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price)
                    }else{
                        //constraints would affect/charge each item in this business
                        for(let item of this.checkout_orders[i].order_items) { 
                            if(this.checkout_orders[i].business_shipping_calculation_method == 10){ //charge each item
                                this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price)
                            }
                            if(this.checkout_orders[i].business_shipping_calculation_method == 11){ //charge each item and the quantities
                                this.checkout_orders[i].order_delivery_fee += Number(item.product_item_order_quantity * option.business_delivery_option_price)
                            }
                        }
                    }
                }else{
                    //option has product delivery fees set
                    //so
                    let ordered_items = this.checkout_orders[i].order_items;
                    //calculate for each item that has set delivery fee
                    for (let item of ordered_items) { 
                        //loop in fees
                        for (let fee of fees) {
                            if(item.product_id == fee.product_delivery_product){ //product has shipping fee
                            //check product delivery fee calculation constraints
                            if(item.product_shipping_calculation_method == 13){ //shipping fee charges all product quantity ordered
                                this.checkout_orders[i].order_delivery_fee += Number(item.order_item_quantity * fee.product_delivery_fee)
                            }
                            if(item.product_shipping_calculation_method == 12){ //shipping fee does not charge product quantity ordered
                                this.checkout_orders[i].order_delivery_fee += Number(fee.product_delivery_fee);
                            }
                            //mark as calculated
                            item.has_calculated_product_delivery_fee = true;
                            item.calculated_product_delivery_fee = Number(fee.product_delivery_fee);
                            item.order_item_delivery_fee = Number(fee.product_delivery_fee);
                            }
                        }
                    
                    }
                    //.../..calculate for each item that has set delivery fee

                    //then calculate for general sellpoint delivery option

                    //check: if no of items with calculated product delivery fee for this option is == to the total no of items in this business cart
                    let sorted_fees = ordered_items.filter(function(item){ return item.has_calculated_product_delivery_fee==true;});
                    //if less than, more calculations to be made
                    if(sorted_fees.length < ordered_items.length){ //more calculations to be made
                        //calculate delivery with Business Constraints
                        if(this.checkout_orders[i].business_shipping_calculation_method == 9){ //one charge for all items ordered in this business
                            this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price)
                        }else{
                            //constraints would affect/charge each item in this business
                            for (let item of ordered_items) { 
                                if(this.checkout_orders[i].business_shipping_calculation_method == 10){ //charge each item
                                    this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price)
                                }
                                if(this.checkout_orders[i].business_shipping_calculation_method == 11){ //charge each item and the quantities
                                    this.checkout_orders[i].order_delivery_fee += Number(item.product_item_order_quantity * option.business_delivery_option_price)
                                }
                            }
                        }
                    }
                    //end more calculations
                }
                //..calculate
              
                //TOTALS
                //update delivery fee with new one
                this.total_orders_amount += Number(this.checkout_orders[i].order_delivery_fee); //general
                this.checkout_orders[i].order_total += Number(this.checkout_orders[i].order_delivery_fee); //sellpoint
                this.total_shipping_fee  += Number(this.checkout_orders[i].order_delivery_fee); //general
                
                //update address
                if(this.delivery_details.length != 0){
                    for(let detail of this.delivery_details) {
                        if(detail.user_delivery_city == option.business_delivery_option){
                            //empty previous city delivery addresses
                            this.checkout_orders[i].order_user_city_delivery_addresses = [];
                            //now push matching addresses to this city
                            this.checkout_orders[i].order_user_city_delivery_addresses.push(detail);
                        }
                    }
                }
            }
            
        },

        setOrderUserCityDeliveryAddress(i,address){
            if(address != undefined){
                this.checkout_orders[i].order_user_delivery_detail = address.address_id; //user-delivery-id
            }
        },

        setUserDeliveryAddress(i,city){
            this.delivery_details.forEach(function(detail) {
                if(detail.user_delivery_city == city){
                    //console.log
                    this.checkout_orders[i].order_user_delivery_address = detail.user_delivery_address;
                }
            }, this);
        },

        //../processing

    
        //payments
        setPaymentOption(option){
            this.payment_mode = option;
        },

        setProcessPaymentSingle(order,index,toggle_view){
            let process_errors = [];
            //validate order city
            if((order.order_delivery_city == undefined) || (order.order_delivery_city == '')){
                // process_errors.push("Please enter delivery location for "+order.order_business);
                if(order.order_business_agent_type && (order.order_business_agent_type == 20)){
                    process_errors.push("Please enter delivery location for "+order.order_business_agent_name);
                }else {
                    process_errors.push("Please enter delivery location for "+order.order_business);
                }
            }else{
                //validate all addresses are set
                if((order.order_user_delivery_address == undefined) || (order.order_user_delivery_address == '')){
                    // process_errors.push("Please enter delivery address for "+order.order_business)
                    if(order.order_business_agent_type && (order.order_business_agent_type == 20)){
                        process_errors.push("Please enter delivery address for "+order.order_business_agent_name);
                    }else {
                        process_errors.push("Please enter delivery address for "+order.order_business);
                    }
                }
                //for order items
                order.order_items.forEach(function(item) {
                    if(item.order_delivery_city){
                        if(item.order_user_delivery_address == undefined){
                            process_errors.push("Please enter delivery address for "+item.product_name);
                        }
                    }
                }, this);
            }
            if(process_errors.length != 0){
                process_errors.forEach(function(err) {
                    //ouput errors
                    this.data_error_message = err;
                    // toastr.error(error, 'Warning!');
                    this.checkout_orders[index].data_processing_message = err;
                    this.checkout_orders[index].show_address_input = true;
                    //this.checkout_orders[index].show_address_input = false;
                    this.componentOrderSummaryKey++;
                }, this);
                    
            }else{
                //prepare payment update data
                if(!order.order_user_delivery_detail){
                    //set new user order
                    order.order_user_new_delivery_detail = true;
                }
                this.data_error_message = "";
                this.checkout_orders[index].data_processing_message = "";
                this.checkout_orders[index].show_address_input = true;
                this.toggleViews(toggle_view); //toggle main view  
            }
        },

        prepProcessPaymentSingle(order,index,payment_mode,payment_status){ //for set and get payment ref from server
            let has_set_payment_ref = 0;
            //checks
            
            var payload = {
                orders_load: this.payment_details.pay_set,
                orders_total_amount: order.total_amount,
                orders_payment_mode: payment_mode,
                orders_payment_status: payment_status,
                orders_active_payment_ref: this.payment_active_resolve_ref
            }

            service.preparePayments(this, payload).then(data => {
                if((data.body.status == 200) || (data.body.status == 404)) { //404//afater no payments found if //conflicts
                    has_set_payment_ref = 1;
                    this.payment_details.payment_ref = data.body.data.data_ref;
                    //console.log(this.payment_details.payment_ref);
                }else {
                    let paymode = data.body.data_active_payment_mode;
                    let paydata = data.body;
                    if(data.body.status == 409) { //conflict flag with payment gateway
                        //check if payment has been previously made and is active
                        if(data.body.data_active_gateway_payment_check == 1){
                            this.verifyServerRavePayment(order,index,payment_mode,paydata);//do for ravepay
                        }else if((data.body.status == 409) && (data.body.data_paid_status == 200)) { //conflict with payment found
                            //check if payment has been previously made and is active
                           this.resolveActivePayment(order,index,payment_mode,paydata);
                        }
                    }else {
                        this.data_processing_message = "Sorry, could not update payment";
                    }
                }
                if(has_set_payment_ref == 1 && (this.payment_details.payment_ref != '')){
                    this.processPaymentSingle(order,index,payment_mode);
                }

                //dissolve
                this.payment_active_resolve_ref = "";
            }).catch((err) => {
                if(err) {
                    this.data_processing_message = "Sorry, could not process information";
                }
                //dissolve
                this.payment_active_resolve_ref = "";
            })
        },

        verifyServerRavePayment(order,index,payment_mode,paydata){
            let payref = paydata.data_active_payment_order_service_ref;
            //server validation
            // let payload =
            // {
            //     "SECKEY": "FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X", //use API secret key
            //     "txref": payref
            // };
            let payload =
            {
                call_url: "https://api.flutterwave.com/v3/transactions/"+payref+"/verify",
                call_method: "GET",
                call_header: ["Content-Type: application/json",
                              "Authorization: FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X"]
            };
            service.verifyRavePayment(this, payload).then(response => {
                //console.log(response.body.status); 
                if ((response.body.status === "success")) {
                    //check if the amount is same as amount you wanted to charge just to be very sure
                    //also add check for currency
                    // if( (response.body.data.amount === order.total_amount) && (response.body.data.currency === "NGN")) { //get currency from server as passed
                    if( (response.body.data.amount === order.total_amount)) { //get currency from server as passed
                        paydata.data_active_gateway_payment_check = "00";
                        paydata.data_active_gateway_payment_log_ref = payref;
                        this.resolveActivePayment(order,index,payment_mode,paydata);//do for ravepay
                    }
                    //self.payment_message = "Payment processed successfully, check your email for your receipts."
                }else{
                    //this.resolveActivePayment(order,index,payment_mode,paydata);
                    //set active payment ref to resolve
                    this.payment_active_resolve_ref = payref;
                    //remake payment by getway
                    this.prepProcessPaymentSingle(order,index,payment_mode,2); //2////set this active payment for resole
                }
                //...//....server validation
            }).catch((err) => {
                if(err) {
                    this.data_processing_message = "Sorry, could not process information";
                }
            })
        },

        resolveActivePayment(order,index,payment_mode,payment_data){
            //add active payment data to pre generated pyment details
            this.payment_details.active_payment_data = payment_data;
            this.payment_details.active_payment_alert = 1;
            this.payment_details.active_payment_ref = payment_data.data_active_payment_order_service_ref;
            
            //then call processpayment
            this.processPaymentSingle(order,index,payment_mode);
        },

        processPaymentSingle(order,index,payment_mode){
            this.activate_processing();
            let active_payment_alert = 0;
            if((this.payment_details.active_payment_alert) && (this.payment_details.active_payment_alert == 1)){
                active_payment_alert = 1;
            }
            if(payment_mode == 1){
                order.order_payment_mode = 1;
                this.checkout_orders[index].order_payment_mode = 1;//gateway
                //this.processRavePayment();
                // this.processPaymentPaystack(this.payment_details,order,index);
                if(active_payment_alert == 1){
                    this.updatePaymentSingle(this.payment_details.active_payment_ref,order,index,"autoUpdate"); 
                }else{
                    this.processPaymentRavepay(this.payment_details,order,index);
                }
                //    this.updatePaymentSingle("test_ref",order,"autoUpdate"); 
                //    this.updatePaymentSingle("test_ref"+(new Date().getTime()),order,"autoUpdate");
            }

            if(payment_mode == 2){
                order.order_payment_mode = 2;
                this.checkout_orders[index].order_payment_mode = 2;//collections
                if(active_payment_alert == 1){
                    this.updatePaymentSingle(this.payment_details.active_payment_ref,order,index,"autoUpdateCollections"); 
                }else{
                    this.updatePaymentSingle(this.payment_details.payment_ref,order,index,"autoUpdateCollections"); 
                }     
            }

            if(payment_mode == 3){
                order.order_payment_mode = 3;
                this.checkout_orders[index].order_payment_mode = 3;//manualTransfer
                if(active_payment_alert == 1){
                    this.updatePaymentSingle(this.payment_details.active_payment_ref,order,index,"manualUpdate"); 
                }else{
                    this.updatePaymentSingle(this.payment_details.payment_ref,order,index,"manualUpdate");
                }
            }
           
       
        },

        processPayment(){
            let process_errors = [];
            //validate all addresses are set
            this.checkout_orders.forEach(function(order) {
                if((order.order_user_delivery_address == undefined) || (order.order_user_delivery_address == '')){
                    //process_errors.push("Please enter delivery address for "+order.order_business)
                    if(order.order_business_agent_type && (order.order_business_agent_type == 20)){
                        process_errors.push("Please enter delivery location for "+order.order_business_agent_name);
                    }else {
                        process_errors.push("Please enter delivery location for "+order.order_business);
                    }
                }
                // if(order.order_delivery_not_set && (order.order_delivery_city == undefined)){
                //     process_errors.push("Please select delivery location for "+order.order_business)
                // }//commented for now till city issue fixed
                //for order items
                order.order_items.forEach(function(item) {
                    if(item.order_delivery_city){
                        if(item.order_user_delivery_address == undefined){
                            process_errors.push("Please enter delivery address for "+item.product_name);
                        }
                    }
                }, this);
            }, this);
            if(process_errors.length != 0){
                process_errors.forEach(function(error) {
                    //ouput errors
                    this.data_error_message = error;
                    toastr.error(error); 
                }, this);
            }else{
                //prepare payment update data
                this.checkout_orders.forEach(function(order) {
                    if(!order.order_user_delivery_detail){
                        //set new user order
                        order.order_user_new_delivery_detail = true;
                    }
                }, this);
                
                this.processCardPayment(this.payment_details);
                // this.processRavePayment();
                // if(this.payment_mode == "card"){
                //     this.processCardPayment(this.payment_details);
                //     //this.updatePayment(this.payment_details.payment_ref);
                // }
                // if(this.payment_mode == "paycode"){
                //     this.processPayCodePayment();
                // }        
            }
        },

        processRavePayment() {
            let self = this;
            var x = getpaidSetup({
                PBFPubKey: service.raveLivePublicKey, //api public key//live
                // PBFPubKey: service.raveTestPublicKey, //test //devlot
                customer_email: self.payment_details.payment_payer_email, // "mail@gmail.com"
                amount:  (Math.round(self.total_orders_amount)),//(Math.round(this.total_orders_amount * 100)),
                customer_phone: self.payment_details.payment_payer_phone, //"234099940409"
                currency: "GBP",
                // currency: "NGN",
                payment_method: "both",
                txref: "GalleryWebsiteOrders"+self.payment_details.payment_ref,
                meta: [{
                    metaname: "GalleryWebsiteOrders",
                    metavalue: self.payment_details.payment_payer_name
                }],
                onclose: function() {},
                callback: function(response) {
                    var txref = response.tx.txRef; // collect flwRef returned and pass to a server page to complete status check.
                    var tx_amount = response.tx.amount;
                    if (
                        response.tx.chargeResponseCode == "00" ||
                        response.tx.chargeResponseCode == "0"
                    ) {
                        self.processing = true;
                        
                        // redirect to a success page
                       // console.log("good to go!"+txref)

                        //server validation
                        // let payload =
                        // {
                        //    "SECKEY": "FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X", //use API secret key
                        //     "txref": txref
                        // };
                        // service.verifyRavePayment(self, payload).then(response => {
                        //     // console.log(response); // 42
                        //     // console.log(response.body.data.status); // 42
                        //     if ((response.body.data.status === "successful") && (response.body.data.chargecode == "00")) {
                        //         //check if the amount is same as amount you wanted to charge just to be very sure
                        //         self.payment_message = "Payment processed successfully, check your email for your receipts."
                                
                        //         if (response.body.data.amount === tx_amount) {
                        //             //enter into db
                                    

                                    // let txn_payload={
                                    //     "txn_ref": txref,
                                    //     "pay": self.user.user_id,
                                    //     "txn_amount": self.wallet_transaction.topay_amt,
                                    //     "processing_fee": self.wallet_transaction.processing_fee,
                                    //     "topup_by_admin": 0,
                                    //     "total_amount": tx_amount
                                    // };
                                    
                                    this.updatePayment(txref);
                            //     }
                            // }
                           
                            
                        // }).catch((err) => {
                        //     //console.log(34545)
                        //    // console.log(err)
                        // })
                        //...//....server validation
                    } else {
                        // redirect to a failure page.
                        //console.log("bad to go!"+txref)
                        self.wallet_payment_message = "Payment unsuccessfull. please try again or contact us"
                    }
    
                    x.close(); // use this to close the modal immediately after payment.
                }
            });
        },

        //paystack
        processPayStackPayment(data) {
            //test--//this.updatePayment("ppp")
            let obj = this;
            //this.amount_paid = data.plan_amount;
            var handler = PaystackPop.setup({
            key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
            Name: data.payment_payer_name,
            // email: data.plan_user_email || "admin@sellpoints.ng",
            email: "keneinfostream@gmail.com",
            // amount:  (Math.round(data.payment_amount * 100)),//(data.plan_amount * 100), //in kobo
            amount:  (Math.round(this.total_orders_amount * 100)),//(data.plan_amount * 100), //in kobo
            ref: data.payment_ref,
            metadata: {
                custom_fields: [
                    {
                        display_name: "",
                        variable_name: "",
                        value: data.payment_payer_name
                    },
                    {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }
                    
                ]
            },
            
            callback: function(response){
                obj.updatePayment(response.trxref); 
                
            },
            onClose: function(){
                alert('window closed');
                //refresh
                location.reload();
            }
            }); 
            handler.openIframe();
        },

        //connect to a payment gateway
        processCardPayment(data) {
            //test--//this.updatePayment("ppp")
            let obj = this;
            //this.amount_paid = data.plan_amount;
            var handler = PaystackPop.setup({
            key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
            Name: data.payment_payer_name,
            // email: data.plan_user_email || "admin@sellpoints.ng",
            email: "keneinfostream@gmail.com",
            // amount:  (Math.round(data.payment_amount * 100)),//(data.plan_amount * 100), //in kobo
            amount:  (Math.round(this.total_orders_amount * 100)),//(data.plan_amount * 100), //in kobo
            ref: data.payment_ref,
            metadata: {
                custom_fields: [
                    {
                        display_name: "",
                        variable_name: "",
                        value: data.payment_payer_name
                    },
                    {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }
                    
                ]
            },
            
            callback: function(response){
                obj.updatePayment(response.trxref); 
                
            },
            onClose: function(){
                alert('window closed');
                //refresh
                location.reload();
            }
            }); 
            handler.openIframe();
        },

        //process payments
        processPaymentPaystack(data,order,index) {
            let obj = this;
            var handler = PaystackPop.setup({
                key: service.paystack_public_test,
                Name: data.payment_payer_name,
                // email: data.payment_payer_email || "admin@sellpoints.ng",
                email: "keneinfostream@gmail.com",
                amount:  (Math.round(order.total_amount * 100)),//(data.plan_amount * 100), //in kobo
                ref: data.payment_ref,
                metadata: {
                    custom_fields: [
                        {
                            display_name: "",
                            variable_name: "",
                            value: data.payment_payer_name
                        },
                        {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: order.order_detail
                        }
                        
                    ]
                },
            
                callback: function(response){
                    obj.updatePaymentSingle(response.trxref,order,index,"autoUpdate"); 
                },

                onClose: function(){
                    alert('window closed');
                    //refresh
                    location.reload();
                }
            }); 
            handler.openIframe();
        },

        processPaymentRavepay(data,order,index) {
            let self = this;
            //prep subaccounts
            let set_subaccounts = [];
            //check if agentsco and commissions
            //agents
            if(order.order_agent_fee > 0){
                var sub_account_0 = {
                    id: order.business_agent_bank_ravepay_subaccount_id, // This assumes you have setup your commission on the dashboard.
                    transaction_charge: (order.order_agent_fee),
                    transaction_charge_type: "flat_subaccount"
                }
                set_subaccounts.push(sub_account_0);
            }
            //commissions
            if(order.order_total_commissions_fee > 0){
                var sub_account_01 = {
                    id: service.spcomms_subaccount_id, // This assumes you have setup your commission on the dashboard.
                    transaction_charge: (order.order_total_commissions_fee),
                    transaction_charge_type: "flat_subaccount"
                }
                set_subaccounts.push(sub_account_01);
            }
            //check if order shipping is born by this business or a delivery company
            let order_business = 0;
            let order_delivery_business = order.order_delivery_business.business_delivery_id;
            if(order_business == order_delivery_business){//order shipping is born by this business
                var sub_account_1 = {
                    id: order.business_bank_ravepay_subaccount_id, // This assumes you have setup your commission on the dashboard.
                    transaction_charge: (order.total_amount - (order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee)),
                    transaction_charge_type: "flat_subaccount"
                }
                set_subaccounts.push(sub_account_1);
            }else{ //order shipping is not born by this business
                var sub_account_1 = {
                    id: order.business_bank_ravepay_subaccount_id, // This assumes you have setup your commission on the dashboard.
                    transaction_charge: (order.total_amount - (order.order_delivery_fee + order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee)),
                    transaction_charge_type: "flat_subaccount"
                };
                set_subaccounts.push(sub_account_1);
                var sub_account_2 = {
                    id: order.order_delivery_business.business_bank_ravepay_subaccount_id, // This assumes you have setup your commission on the dashboard.
                    transaction_charge: (order.order_delivery_fee),
                    transaction_charge_type: "flat_subaccount"
                }
                set_subaccounts.push(sub_account_2);
            }
            //..//prep sub accounts
            
            var x = getpaidSetup({
                PBFPubKey: service.ravepay_public_test, //test //devlot
                // PBFPubKey: service.ravepay_public_live_paga, //api public key
                customer_email: "keneinfostream@gmail.com",//self.customer.customerEmail, // "mail@gmail.com"
                amount: order.total_amount,//(Math.round(order.total_amount))//self.total_fee,
                customer_phone: data.payment_payer_phone, //"234099940409"
                currency: "NGN",
                payment_method: "both",
                txref:data.payment_ref,
                // subaccounts: [
                //     {
                //       id: order.business_bank_ravepay_subaccount_id, // This assumes you have setup your commission on the dashboard.
                //       transaction_charge: (order.total_amount - order.order_processing_fee),
                //       transaction_charge_type: "flat_subaccount"
                //     }
                // ],
                subaccounts: set_subaccounts,
                meta: [{
                    metaname: "AFPAY",
                    metavalue: data.payment_payer_name,
                }],
                onclose: function() {
                   
                },
                callback: function(response) {console.log("response.body.status"); console.log(response);
                    var txref = response.tx.txRef; // collect flwRef returned and pass to a server page to complete status check.
                    var tx_amount = response.tx.amount;
                    if (
                        response.tx.chargeResponseCode == "00" ||
                        response.tx.chargeResponseCode == "0"
                    ) {
                        self.updatePaymentSingle(txref,order,index,"autoUpdate"); 
                        //server validation
                        // let payload =
                        // {
                        //    "SECKEY": service.ravepay_secret_live_paga, //use API secret key
                        //     "txref": txref
                        // };
                        // service.verifyRavePayment(self, payload).then(response => {
                            
                        // }).catch((err) => {
                            
                        // })
                    } else {
                        self.payment_message = "Payment unsuccessfull. please try again or contact us"
                    }
                }
            });
        },
        //../process payments

        // update payments
        updatePaymentSingle(payment_ref,order,index,update_type) {
            //some settings
            this.process_orders_update = [];
            let processing_fee_transaction_type = 0;
            if(order.order_processing_fee_status == 3){//seller pays
                processing_fee_transaction_type = 2;//processing fee deduct from balance
                //add to orders data
                order.processing_fee_transaction_type = processing_fee_transaction_type;
                order.processing_fee_transaction_amount = order.order_processing_fee;
            }
            this.payment_details.payment_details = order.order_details;
            let payment_service_payment_data = this.payment_details;
            //add more data to payment_service_payment_data
            this.process_orders_update.push(order);
            payment_service_payment_data.payment_services = this.process_orders_update;

            var payload = {
                payment_order_type:"single",
                payment_order_ref: payment_ref,
                payment_order_amount_paid: order.total_amount,
                payment_user_id: this.user.user_id,
                payment_orders: order,
                payment_details: order.order_details,
                //processing fee details
                processing_fee_transaction_type: processing_fee_transaction_type,
                processing_fee_transaction_amount:order.order_processing_fee,
                //manual payment updates and confirmation
                payment_update_type:update_type,

                //updated use for now //new version with payment service
                payment_service_payment_data: payment_service_payment_data,
                payment_service_mode: order.order_payment_mode,
                payment_service_type:"single",
                //
                payment_service_user_id: this.user.user_id,
                payment_service_amount_paid: order.total_amount,
                payment_service_processing_fee_transaction_type: processing_fee_transaction_type,
                payment_service_processing_fee_transaction_amount: order.order_processing_fee,
                
            }
            let navi = this.$router;
            
            if(payment_ref != "") {
            service.updatePayment(this, payload).then(data => {console.log("loopcc"+data.body.status)
                if((data.body.status == 200) || (data.body.status == 400)) {
                    //return order id if one and navigate with it to orders
                    // toastr.success("Payment Processed!", "Success!");
                    this.data_processing_message = "Payment Processed!";
                    this.checkout_orders[index] = data.body.data;
                    this.processed_single_order_count++;
                    // location.replace("/orders/");
                    this.deactivate_processing();
                }else {
                    //console.log("error")
                    // toastr.error('Sorry, could not update payment', 'Warning!');
                    this.data_processing_message = "Sorry, could not update payment";
                    this.deactivate_processing();
                }
            }).catch((err) => {
                if(err) {
                    // console.log(err)
                    // toastr.error('Sorry, could not process information', 'Warning!');
                    this.data_processing_message = "Sorry, could not process information";
                    this.deactivate_processing();
                }
            })
            }else {
                // toastr.error('Something went wrong', 'Warning!');
                this.data_processing_message = "Something went wrong";
                this.deactivate_processing();
            }
            
        },

        updatePayment(payment_ref) {

            var payload = {
                payment_order_ref: payment_ref,
                payment_order_amount_paid: this.total_orders_amount,
                payment_processing_fees: this.total_processing_fee,
                payment_user_id: this.user.user_id,
                payment_orders: this.checkout_orders,
                payment_details: this.payment_details.payment_service,
            }

            let navi = this.$router;
            
            if(payment_ref != "") {
                service.updatePayment(this, payload).then(data => {
                    if((data.body.status == 201) || (data.body.status == 200) || (data.body.status == 400)) {
                        //return order id if one and navigate with it to orders
                        //toastr.success("Payment Processed!", "Success!");
                        location.replace("/orders/");
                        // if(this.request_page != ''){
                        //     this.$router.push(this.request_page);
                        // }else {
                        //     this.$router.go('/');
                        // }
                    }else {
                        //console.log("error")
                        //toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        // console.log(err)
                        //toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                //toastr.error('Something went wrong', 'Warning!');
            }
            
        },

        //....payments

    },
    created(){
        document.title = "Checkout" + " | " + service.app_name;
        this.preset();
        this.loading = true;
        // if((localStorage.getItem("sp_token") != undefined) || (localStorage.getItem("sp_token") != null)){
        //     this.new_account = false;
        //     this.preset();
        // }else{
        //     this.getCheckoutLocalOrder();
        // }
        this.getStates();
    }
     
}


// WEBPACK FOOTER //
// ./src/pages/Orderpoint/Checkout/script.js